export default "__VITE_ASSET__d69bdeb3__"